import adAxios, { MAxiosResponse, maxiosGlobalConfig } from '@ad/ad_utils/lib/utils/mAxios';
import errCode from './errCode';

const axios = adAxios.axiosInstance;
axios.defaults.timeout = 60000;
const get = adAxios.get2;
const post = adAxios.post2;
const get1 = adAxios.get;
const post1 = adAxios.post;
const { postFormData } = adAxios;

maxiosGlobalConfig.showApiHint = false;
axios.interceptors.response.use(
  async (res) => {
    const { code, msg } = res as any as MAxiosResponse;

    // 没有权限先申请权限
    if (code === errCode.NO_AUDIT) {
      const redirect = `${window.location.origin}/gateway/index`;
      if (window.location.href !== redirect) {
        window.location.href = redirect;
      }
      (res as any).code = errCode.SUCCESS;
    }
    if (code === errCode.EXPIRE_LOGIN || code === errCode.NEED_LOGON) {
      window.location.href = msg;
    }

    return res;
  },
);

export {
  axios,
  get,
  post,
  get1,
  post1,
  postFormData,
};
